import React from 'react';

import { graphql } from 'gatsby';

import { MewaSteps, MewaStepsProps } from '@mewa/ui';

import { StrapiComponentType } from '../types';
import { MewaEssentialsSection } from './types';

export const MewaStepsFragment = graphql`
  fragment MewaStepsFragment on STRAPI__COMPONENT_MEWA_ESSENTIALS_MEWA_STEPS {
    tabTitle
    steps {
      icon
      title: headline
      description
    }
    strapi_component
  }
`;

export const componentName = 'mewa-essentials.mewa-steps';

export type MewaStepsData = StrapiComponentType<typeof componentName> &
  MewaStepsProps;

export const isMewaSteps = (
  component: MewaEssentialsSection,
): component is MewaEssentialsSection<MewaStepsData> => {
  return component.strapi_component === componentName;
};

export const StrapiMewaSteps = ({ data }: { data: MewaStepsData }) => {
  return <MewaSteps steps={data.steps} />;
};
